import { render, staticRenderFns } from "./InstrumentCorrection.vue?vue&type=template&id=20597d10&scoped=true"
import script from "./InstrumentCorrection.vue?vue&type=script&lang=js"
export * from "./InstrumentCorrection.vue?vue&type=script&lang=js"
import style0 from "./InstrumentCorrection.vue?vue&type=style&index=0&id=20597d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20597d10",
  null
  
)

export default component.exports